import {
  CLEAR_FILTERS,
  CHANGE_PAGE,
  CHANGE_SEARCH_TEXT,
  CHANGE_ASSIGNMENT_TYPE_FILTER,
  CHANGE_BROKER_FILTER,
  CHANGE_PROPERTY_TYPE_FILTER,
  CHANGE_STATUS_FILTER,
} from '../actions/query';

export default function(state = {}, action) {
  switch (action.type) {
  case CHANGE_PAGE:
    return {
      ...state,
      page: action.page
    };
  case CHANGE_SEARCH_TEXT:
    return {
      ...state,
      searchText: action.value,
      page: 1
    };
  case CHANGE_ASSIGNMENT_TYPE_FILTER:
    return {
      ...state,
      assignmentTypeFilter: action.assignmentTypeFilter,
      page: 1
    };
  case CHANGE_BROKER_FILTER:
    return {
      ...state,
      brokerFilter: action.brokerFilter,
      page: 1
    };
  case CHANGE_PROPERTY_TYPE_FILTER:
    return {
      ...state,
      propertyTypeFilter: action.propertyTypeFilter,
      page: 1
    };
  case CHANGE_STATUS_FILTER:
    return {
      ...state,
      statusFilter: action.statusFilter,
      page: 1
    };
  case CLEAR_FILTERS:
    return {
      ...state,
      searchText: '',
      assignmentTypeFilter: [],
      brokerFilter: null,
      propertyTypeFilter: [],
      statusFilter: [],
      page: 1
    };
  default:
    return state;
  }
}
